// extracted by mini-css-extract-plugin
export default {"form":"Form_form__kmNRU","list":"Form_list__epnQL","wrapper":"Form_wrapper__ZmxRc","description":"Form_description__G5-C8","button":"Form_button__7Kt3D"};